import React from "react";
import { motion } from "framer-motion"; // Importamo motion
import Burger from "../../Assets/Menu/Bacon-Burger.jpg";
import Lasagna from "../../Assets/Menu/ChiliInfernoLasagna.jpg";
import SpicyChicken from "../../Assets/Menu/SpicyChicken.jpg";

const HomeFeatures = () => {
  const features = [
    { id: 1, name: "Godfather Burger", price: "8.50 €", img: Burger },
    { id: 2, name: "Pasta Carbonara", price: "10.00 €", img: Lasagna },
    { id: 3, name: "Domaća Lepinja", price: "2.00 €", img: SpicyChicken },
  ];

  // Varijante za kontejner (da djeca iskaču jedan po jedan)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Razmak između pojavljivanja kartica
      },
    },
  };

  // Varijante za svaku pojedinačnu karticu
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 30 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <section className="home-features">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Izdvajamo za Vas
      </motion.h2>

      <motion.div
        className="features-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {features.map((f) => (
          <motion.div
            key={f.id}
            className="feature-card"
            variants={cardVariants}
            whileHover={{
              y: -10,
              transition: { duration: 0.3 },
            }} // Lagano se digne kad se pređe mišem
          >
            <div
              className="img-holder"
              style={{ backgroundImage: `url(${f.img})` }}
            >
              {/* Možemo dodati i mali overlay na slici pri hoveru kroz CSS */}
            </div>
            <h3>{f.name}</h3>
            <p className="price">{f.price}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default HomeFeatures;
